import React from 'react'
import Hero from '../Components/Hero'
import Quality from '../Components/Quality'
import DogImagge from '../Components/DogImage'
import Progressbar from '../Components/Progressbar'
import AllProducts from '../Components/AllProducts/AllProducts'
import Categories from '../Components/Categories'
import Feature from '../Components/Popular/Feature'

// import NewsLetter from '../Components/NewsLetter/NewsLetter'

const Shop = () => {
  return (
    <div>
      <Hero />
      <Quality />
      <DogImagge />
      <Categories />
      <Feature />
      <Progressbar />
      <AllProducts/>
    </div>
  )
}

export default Shop
